'use es6';

export default {
  GIVEN_NAME: 'given',
  FAMILY_NAME: 'family'
};